/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Layer} from 'baseui/layer'
import {KIND, PLACEMENT, toaster, ToasterContainer} from 'baseui/toast'
import isEmpty from 'lodash/isEmpty'
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {clearNotification} from '../../features/persistence/notification-slice'

const Toaster = () => {
  const notification = useSelector(state => state.notification)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isEmpty(notification)) {
      const message = notification?.message ?? 'Unknown Error'
      const kind = notification?.kind ?? KIND.negative

      toaster[kind](message, {autoHideDuration: 5000, onClose: () => dispatch(clearNotification())})
    }
  }, [dispatch, notification])

  return (
    <Layer>
      <ToasterContainer placement={PLACEMENT.bottomRight} />
    </Layer>
  )
}

export default Toaster
